import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { api } from "@/lib/api";
import { formatIsoDay } from "@/lib/format";
import { useAuth } from "@/context/AuthContext";

export default function DelayedContainersCard() {
  const { can } = useAuth();
  const [d, setD] = useState(null);
  const ok = can("ithalat");
  useEffect(() => { if (ok) api.get("/dashboard/delayed-containers").then(({ data }) => setD(data)).catch(() => {}); }, [ok]);
  if (!ok || !d || d.items.length === 0) return null;
  return (
    <div className="panel border-rose-300 bg-rose-50 p-3 mb-4" data-testid="delayed-containers-card">
      <div className="flex items-center gap-2 text-rose-800 font-semibold text-sm mb-2"><AlertTriangle className="h-4 w-4" />Geciken Konteynerler ({d.items.length}) <span className="text-[11px] font-normal text-rose-600">· gecikme &gt; {d.threshold_days} gün</span>
        <Link to="/raporlar/ithalat?delayed=1" className="ml-auto text-[12px] font-normal underline" data-testid="delayed-containers-report-link">Rapora git</Link></div>
      <div className="divide-y divide-rose-200">
        {d.items.slice(0, 8).map((x) => (
          <Link key={x.id} to={`/ithalat/${x.id}`} className="flex flex-wrap gap-x-3 py-1.5 text-[12px] hover:bg-rose-100 px-1 rounded" data-testid={`delayed-container-${x.file_no}`}>
            <b className="font-mono">{x.file_no}</b><span className="font-mono">{x.container_no || "—"}</span><span className="text-slate-600 truncate max-w-[220px]">{x.cari}</span>
            <span>{x.pod || "—"}</span><span className="text-slate-500">ETA {formatIsoDay(x.first_eta)} → <b>{formatIsoDay(x.current_eta)}</b></span>
            <span className="ml-auto font-semibold text-rose-700" data-testid={`delayed-days-${x.file_no}`}>+{x.delay_days} gün</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
